/**
 * ---------------------------------------------------------------------------------------
 * Comparison data's expected format
 * ---------------------------------------------------------------------------------------
 *
 * [
 *    {
 *      title: '',
 *      total: '',
 *      performance: '',
 *      units: '',
 *      data: [
 *        {
 *          name: 'current',
 *          data: {
 *            `${date}`: '',
 *            ....
 *          }
 *        },
 *        {
 *          name: 'previous',
 *          data: {
 *            `${date}`: '',
 *            ....
 *          }
 *        }
 *      ]
 *    },
 *    ....
 * ]
 */
import _ from 'lodash'
import Moment from 'moment'

// Inverted comparison points.
const INVERTED_COMPARISON = ['rejected payments', 'expired requests', 'rejected requests']

class ComparisonDataTransformer {
  static transform (data, unit) {
    let comparisonData = { 'data': [] }
    _.forIn(data, (value, key) => {
      comparisonData.data.push({
        title: _.capitalize(_.lowerCase(key)),
        total: value.currentTotal,
        performance: Math.round(((value.currentTotal - value.previousTotal) / ((value.previousTotal === 0) ? 1 : value.previousTotal) * 100)),
        data: ComparisonDataTransformer.formatTheChartLabels(value.data),
        unit: unit,
        invert: INVERTED_COMPARISON.includes(_.lowerCase(key))
      })
    })
    return comparisonData
  }

  static formatTheChartLabels (data) {
    const dataPoints = _.toPairs(data[1].data)
    // Subtract the milliseconds from the first date to the last date
    let milliSecondDiff = (new Date(dataPoints[dataPoints.length - 1][0])).getTime() - (new Date(dataPoints[0][0])).getTime()
    let derivedWeeks = Math.ceil(Moment.duration(milliSecondDiff, 'milliseconds').asWeeks())
    let weeks = (derivedWeeks < 1) ? 1 : derivedWeeks
    // Format the legend labels
    data[0].name = 'Current'
    data[1].name = weeks + ' week' + (weeks > 1 ? 's' : '') + ' ago'
    return data
  }
}

export default ComparisonDataTransformer



// WEBPACK FOOTER //
// ./src/api/transformers/ComparisonDataTransformer.js